/* Diese Klasse enthält alle Werte eines
 * generischen Eintrages in einer Schlüsseltabelle. */
export class GenericValue {
    id: number;
    text: string;
    hiskeyId?: number;
    shorttext?: string;
    defaulttext?: string;
    longtext?: string;
    uniquename?: string;
    sortorder?: number;
    objGuid?: string;

    constructor( id?: number, text?: string, hiskeyId?: number, shorttext?: string, defaulttext?: string, uniquename?: string, longtext?: string ) {
        this.id = id;
        this.text = text;
        this.hiskeyId = hiskeyId;
        this.shorttext = shorttext;
        this.defaulttext = defaulttext;
        this.uniquename = uniquename;
        this.longtext = longtext;
    }
}
